export const SCREENS = {

  MOBILE: "(min-width: 768px)",

  TABLET:   "(min-width: 1024px)",

  DESKTOP: "(min-width: 1280px)",
};
